import { render, staticRenderFns } from "./BiometricsImport.vue?vue&type=template&id=710ceb68"
import script from "./BiometricsImport.vue?vue&type=script&lang=js"
export * from "./BiometricsImport.vue?vue&type=script&lang=js"
import style0 from "./BiometricsImport.vue?vue&type=style&index=0&id=710ceb68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports